module.exports = __webpack_public_path__ + "static/media/thenightly_app_qr_logo.0f4404e2.webp";